import { useEffect, useRef, useState } from 'react';
import { WorkStationsSettingsService } from '../../../services/workStationsSettingsService';
import { AuthService } from '../../../services/authService';
import { INACTIVITY_TIME_UNITS } from '../../../config/constants/workStationsConstants';

export function useWorkStationInactivityHandler(lastActivityDate, callback) {
  const [maxInactivityTime, setMaxInactivityTime] = useState(null);
  const savedCallback = useRef(callback);

  const convertToMilliseconds = (time, unit) => {
    const timeUnitFactors = {
      [INACTIVITY_TIME_UNITS.MINUTES.value]: 60 * 1000,
      [INACTIVITY_TIME_UNITS.HOURS.value]: 60 * 60 * 1000,
    };
    return time * (timeUnitFactors[unit] || timeUnitFactors[INACTIVITY_TIME_UNITS.MINUTES.value]);
  };

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const { workStationsSettings } = await WorkStationsSettingsService.getSettings();
        if (!workStationsSettings?.checkInactivityTime) {
          setMaxInactivityTime(null);
          return;
        }
        const { inactivityTime, inactivityTimeUnit } = workStationsSettings;
        setMaxInactivityTime(convertToMilliseconds(inactivityTime, inactivityTimeUnit));
      } catch (error) {
        setMaxInactivityTime(null);
      }
    };
    fetchSettings();
  }, []);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    if (maxInactivityTime == null) {
      return;
    }

    const timerId = setTimeout(() => {
      savedCallback.current();
    }, maxInactivityTime);

    return () => {
      clearTimeout(timerId);
    };
  }, [maxInactivityTime, lastActivityDate]);

  const registerActivity = () => {
    AuthService.registerActivity();
  };

  return { maxInactivityTime, registerActivity };
}
